import FieldPermissionList from './FieldPermissionList'
export {FieldPermissionList}
export default FieldPermissionList
